import owd from 'owd/owd';

export default class FooterInfo extends owd.Component {
	init() {
        this.bind();
	}

	bind() {
        this.on('mouseenter', (e) => {
            if (!window.matchMedia('(max-width: 767px)').matches) {
                e.preventDefault();
                this.$element.parent().addClass('active');
            }
        });

        $('.footer').on('mouseleave', (e) => {
            if (!window.matchMedia('(max-width: 767px)').matches) {
                e.preventDefault();
                this.$element.parent().removeClass('active');
            }
        });

        this.on('click', (e) => {
            if (window.matchMedia('(max-width: 767px)').matches) {
                e.preventDefault();
                this.$element.parent().addClass('active');
            }
        });
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('footer-info', {
	component: FooterInfo
});
